import { motion } from 'motion/react';
import { ArrowLeft, SearchX } from 'lucide-react';
import { Button } from './ui/button';

export interface NotFoundPageProps {
  /** Headline. Defaults to "Page not found". */
  title?: string;
  /** One line of explanation under it. */
  message?: string;
  /** The button back to the app's start page. */
  homeLabel?: string;
}

/**
 * Every app's catch-all route (#314) — previously a copy per app in two
 * different designs. Goes home with a full load of `/`, so this package needs
 * no router.
 */
export function NotFoundPage({
  title = 'Page not found',
  message = "That address doesn't match anything here.",
  homeLabel = 'Back to the start',
}: NotFoundPageProps) {
  return (
    <div className="flex min-h-[60dvh] flex-col items-center justify-center gap-6 text-center">
      <motion.div
        initial={{ scale: 0.8, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ type: 'spring', stiffness: 300, damping: 20 }}
        className="flex h-24 w-24 items-center justify-center rounded-full bg-orange-100"
      >
        <SearchX className="h-12 w-12 text-orange-500" />
      </motion.div>
      <div className="space-y-2">
        <h2 className="text-lg font-semibold text-slate-900">{title}</h2>
        <p className="max-w-sm text-sm text-slate-500">{message}</p>
      </div>
      <Button onClick={() => window.location.assign('/')} className="min-h-11">
        <ArrowLeft className="mr-2 h-4 w-4" /> {homeLabel}
      </Button>
    </div>
  );
}
